"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valfenera": {
    "4e447a32": [{
      "hkey": "9cd3ad2a",
      "slug": "valsuolo",
      "name": "Valsuolo",
      "primary": true,
      "skipSearch": false
    }],
    "alzuolo": [{
      "hkey": "9cd3ad2a",
      "slug": "valsuolo",
      "name": "Valsuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0d636b54": [{
      "hkey": "195cf6bb",
      "slug": "valfenera",
      "name": "Valfenera",
      "primary": true,
      "skipSearch": false
    }],
    "bricco-sossi": [{
      "hkey": "195cf6bb",
      "slug": "valfenera",
      "name": "Valfenera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;